import React from "react";
import ProductGallery from "web/react/components/product-gallery/product-gallery";

interface PDPGalleryProps {
    product: Product;
    features: { [key: string]: any };
    relatedProducts?: ProductCard[];
    clickLeadUrl: string;
    hasRelatedProductsSidebar: boolean;
}

function PDPGallery({
    features,
    product,
    relatedProducts,
    clickLeadUrl,
    hasRelatedProductsSidebar,
}: PDPGalleryProps): React.ReactElement {
    let isSwipeOnRedirect = features.pmt_221_swipe_redirect && product.images.length >= 3;

    return (
        <ProductGallery
            dotsInsideGallery={features.uj_dots_inside_gallery}
            relatedProducts={relatedProducts}
            images={product.images}
            currentLinkId={product.link_ids ? product.link_ids[0] : undefined}
            swipeRedirect={isSwipeOnRedirect}
            clickRedirect={features.seo_pdp_image_link_redirect}
            clickLeadUrl={clickLeadUrl}
            hasRelatedProductsSidebar={hasRelatedProductsSidebar}
        />
    );
}

export default PDPGallery;
